import { LOGIN_SUCCESS, LOGIN_FAILED, LOCKOUT,LOGOUT_SUCCESS, MFA_REQUIRED,
    ACCOUNT_SERVICE_STATUS_UPDATED,
    LOGIN_BAD_MAGIC, CSR_LOGIN_SUCCESS, CSR_CLEAR_SELECTED } from '../../actions/actionTypes';

const initialState = {
    account: null,
    csrAccount: null,
    loginError: false,
    mfaRequired: false,
    accountServiceEnabled: false,
    lockout: false,
    isGuest: false,
    announcement: {
        banner_enabled: false
    },
    loginNotice: {
        notice_enabled: false
    },
    accountServiceStatusUpdated: false
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return Object.assign({}, state, {
                account: action.profile,
                isGuest: action.profile.is_guest,
                loginError: false,
                mfaRequired: false,
                lockout: false
            });

        case LOGIN_FAILED:
            return Object.assign({}, state, {
                account: null,
                loginError: true,
                mfaRequired: false,
                lockout: false
            });

        case LOGIN_BAD_MAGIC:
            return Object.assign({}, state, {
                account: null,
                loginError: true,
                mfaRequired: false,
                lockout: false
            })

        case LOCKOUT:
            return Object.assign({}, state, {
                account: null,
                loginError: false,
                mfaRequired: false,
                lockout: true
            });

        case MFA_REQUIRED:
            return Object.assign({}, state, {
                account: null,
                loginError: false,
                mfaRequired: true,
                lockout: false
            });

        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                account: null,
                csrAccount: null,
                loginError: false,
                mfaRequired: false,
                lockout: false
            });

        case ACCOUNT_SERVICE_STATUS_UPDATED:
            return Object.assign({}, state, {
                accountServiceEnabled: action.enabled,
                announcement: action.announcement,
                loginNotice: action.loginNotice,
                accountServiceStatusUpdated: true
            });

        case CSR_LOGIN_SUCCESS:
            return Object.assign({}, state, {
                csrAccount: action.profile,
                loginError: false,
                mfaRequired: false,
                lockout: false
            });

        case CSR_CLEAR_SELECTED:
            return Object.assign({}, state, {
                account: null,
            });

        default:
            return state;
    }
};

export default loginReducer;
